module.exports = __webpack_public_path__ + "static/media/swatches.2add6fe7.svg";